import React from "react";
import axios from "axios";
import { Link as ReactRouterLink, useHistory } from "react-router-dom";
///@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Row,
    Panel,
    useAddToast,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import ExternalDashboardForm, {
    ExternalDashboard,
} from "../../forms/ExternalDashboardForm";

export const ExternalDashboardCreate = ({ path }) => {
    const history = useHistory();
    const addToast = useAddToast();

    const item: ExternalDashboard = {
        id: null,
        name: "",
        url: "",
        description: "",
    };

    const submitForm = (values) => {
        return axios.post(`/api/v1/admin/external`, values).then(({ data }) => {
            addToast({
                type: "success",
                content: trans("External Dashboard Created"),
                showFor: 5000,
            });
            // console.log(data);
            //As creation was successful move them on to the appropriate listing page
            history.push(`${path}`);
        });
    };
    return (
        <div>
            <PageTitle
                title={
                    <React.Fragment>
                        {trans("New External Dashboard")}
                    </React.Fragment>
                }
            >
                <IconTextButton
                    as={ReactRouterLink}
                    to={path}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>

            <Row>
                <Panel>
                    <ExternalDashboardForm
                        item={item}
                        submitForm={submitForm}
                    />
                </Panel>
            </Row>
        </div>
    );
};

export default ExternalDashboardCreate;
